import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { v4 as uuidv4 } from 'uuid';
import update from 'immutability-helper';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import { toast } from 'react-toastify';

import CollectionCard from './CollectionCard';
import TargetBox from './TargetBox';

import PageTitle from '../../../common/PageTitle';
import Button from '../../../common/Button';

import {
  fetchGetCollections,
  fetchGetCatalogs,
  fetchUpdateCatalog,
} from '../../../../actions/collections';
import { showModal } from '../../../../actions/modal';

import { parseError } from '../../../../helpers';

const Wrapper = styled('div')`
  .catalog-column {
    position: relative;
    .show-notification-block {
      border-radius: 4px;
      border: 1px #ccc dashed;
      padding: 0 5px;
      width: 100%;
      height: 300px;
      position: absolute;
      top: 60px;
      left: 0;
      .drop-notification-block {
        display: flex;
      }
    }
    .drop-notification-block {
      position: absolute;
      top: 140px;
      left: 0;
      line-height: 1.4;
      display: none;
      align-items: center;
      color: #ccc;
      padding: 0 25px;
      pointer-events: none;
      .fe-alert-circle {
        font-size: 20px;
        margin-right: 10px;
        pointer-events: auto;
      }
    }
  }

  .dd-item {
    cursor: pointer;
    &.catalog-item {
      cursor: initial;
    }
    .dd-handle {
      padding: 12px 16px;
      &.is-hovered {
        border-color: #6a41b2;
      }
    }
    .catalog-item-collapse {
      margin-right: 5px;
    }
    .put-before {
      width: 100%;
      height: 5px;
      background-color: #6a41b2;
    }
  }
  .custom-dd > ol,
  .custom-dd > div > ol {
    min-height: 300px;
  }

  .card-box-custom {
    padding: 1.5rem 1.5rem 5rem;
  }

  .h-100 {
    height: 100%;
  }
`;

const convertItemsToCatalog = (data) => {
  return data.reduce((a, c) => {
    if (c.id !== 'main') {
      const obj = {
        title: c.title,
        collectionId: c.originalId,
        items: c.children && c.children.length ? convertItemsToCatalog(c.children) : null,
      };
      a.push(obj);
    }
    return a;
  }, []);
};

const convertCatalogToItems = (data, collections, level = 1) => {
  return data.reduce((a, c) => {
    const currentCollection = collections.find((col) => col.id === c.collectionId);

    if (currentCollection) {
      const obj = {
        ...currentCollection,
        originalId: currentCollection.id,
        id: uuidv4(),
        title: c.title || currentCollection.title,
        level,
      };
      if (c.items && c.items.length) {
        obj.children = convertCatalogToItems(c.items, collections, level + 1);
      }
      a.push(obj);
    }
    return a;
  }, []);
};

const CatalogTuning = (props) => {
  const { data, fetchGetCollections, fetchGetCatalogs, fetchUpdateCatalog, showModal } = props;

  const [loading, setLoading] = useState(false);
  const [collectionList, updateCollectionList] = useState([]);
  const [catalogList, updateCatalogList] = useState([]);
  const [collapsedItems, updateCollapsedItems] = useState([]);
  const [befores, setBefores] = useState({});
  const [catalogs, setCatalogs] = useState([]);

  useEffect(() => {
    (async function () {
      const result = await Promise.all([fetchGetCollections(), fetchGetCatalogs()]);

      const collections = result[0];
      const collectionList = collections.map((c) => ({ ...c, level: 9999 }));
      updateCollectionList(collectionList);

      const catalogs = result[1];
      if (catalogs && catalogs.length) {
        const result = convertCatalogToItems(catalogs[0].items, collectionList);
        updateCatalogList(result);
        setCatalogs(catalogs);
      }
    })();
  }, []);

  const moveCatalogCard = useCallback(
    (dragItem, hoverItem, dragIndex, hoverIndex) => {
      const newDragItem = Object.assign({}, dragItem);
      const newHoverItem = Object.assign({}, hoverItem);

      function findAndReplace(arr, replaced = false) {
        if (replaced) return arr;
        let newArr = arr.slice();
        let dragDeletingIndex = null;
        for (let i in newArr) {
          if (
            !replaced &&
            newArr[hoverIndex] &&
            newArr[hoverIndex].id === newHoverItem.id &&
            newArr[dragIndex] &&
            newArr[dragIndex].id === newDragItem.id
          ) {
            dragDeletingIndex = i;
            replaced = true;
          }
          if (replaced) {
            break;
          } else {
            if (arr[i].children && arr[i].children.length) {
              arr[i].children = findAndReplace(arr[i].children, replaced);
            }
          }
        }
        if (dragDeletingIndex !== null) {
          newArr = update(newArr, {
            $splice: [
              [dragIndex, 1],
              [hoverIndex, 0, newDragItem],
            ],
          });
        }
        return newArr;
      }

      const newCatalogList = findAndReplace(catalogList);
      updateCatalogList(newCatalogList);
      //handleEditCatalog(newCatalogList);
    },
    [catalogList],
  );

  const pushCard = useCallback(
    (dragItem, hoverItem, isNew) => {
      const newDragItem = Object.assign({}, dragItem, { level: hoverItem.level + 1 });
      const newHoverItem = Object.assign({}, hoverItem);
      if (!newHoverItem.children) {
        newHoverItem.children = [];
      } else {
        if (newHoverItem.children.find((i) => i.id === newDragItem.id)) {
          return false;
        }
      }
      if (isNew) {
        newDragItem.originalId = newDragItem.id;
        newDragItem.id = uuidv4();
      }
      newHoverItem.children.push(newDragItem);

      function findAndReplace(arr, findHover = false, findDrag = isNew ? true : false) {
        if (findHover && findDrag) return arr;
        const newArr = arr.slice();
        let dragDeletingIndex = null;
        for (let i in newArr) {
          if (!findHover && newArr[i].id === newHoverItem.id) {
            newArr[i] = newHoverItem;
            findHover = true;
          }
          if (!findDrag && newArr[i].id === newDragItem.id) {
            dragDeletingIndex = i;
            findDrag = true;
          }
          if (findDrag && findHover) {
            break;
          } else {
            if (arr[i].children && arr[i].children.length) {
              arr[i].children = findAndReplace(arr[i].children, findHover, findDrag);
            }
          }
        }
        if (dragDeletingIndex !== null) newArr.splice(dragDeletingIndex, 1);
        return newArr;
      }

      const newCatalogList = findAndReplace(catalogList);
      updateCatalogList(newCatalogList);
      //handleEditCatalog(newCatalogList);
    },
    [catalogList],
  );

  const pushCardToFirstLevel = useCallback(
    (dragItem) => {
      const newDragItem = Object.assign({}, dragItem, { level: 1 });
      function findAndReplace(arr, findDrag = false) {
        if (findDrag) return arr;
        const newArr = arr.slice();
        let dragDeletingIndex = null;
        for (let i in newArr) {
          if (!findDrag && newArr[i].id === newDragItem.id) {
            dragDeletingIndex = i;
            findDrag = true;
          }
          if (findDrag) {
            break;
          } else {
            if (arr[i].children && arr[i].children.length) {
              arr[i].children = findAndReplace(arr[i].children, findDrag);
            }
          }
        }
        if (dragDeletingIndex !== null) newArr.splice(dragDeletingIndex, 1);
        return newArr;
      }

      const newCatalogList = findAndReplace(catalogList);
      newCatalogList.push(newDragItem);
      updateCatalogList(newCatalogList);
      //handleEditCatalog(newCatalogList);
    },
    [catalogList],
  );

  const handleDropToCatalog = ({ cardType, originalItem }, monitor) => {
    const newCatalogList = catalogList.slice();
    if (cardType === 'collection') {
      if (monitor.isOver({ shallow: true })) {
        newCatalogList.push({
          ...originalItem,
          id: uuidv4(),
          originalId: originalItem.id,
          level: 1,
        });
      }
    } else {
      if (monitor.isOver({ shallow: true })) {
        pushCardToFirstLevel(originalItem);
        return undefined;
      }
    }
    updateCatalogList(newCatalogList);
    //handleEditCatalog(newCatalogList);
  };

  const handleCollapse = (item) => {
    const newCollapsedItems = collapsedItems.slice();
    const findCollapsedIndex = newCollapsedItems.findIndex((i) => i.id === item.id);
    if (findCollapsedIndex > -1) {
      newCollapsedItems[findCollapsedIndex].status = !newCollapsedItems[findCollapsedIndex].status;
    } else {
      newCollapsedItems.push({ id: item.id, status: false });
    }
    updateCollapsedItems(newCollapsedItems);
  };

  const handleEditCatalog = (newData) => {
    const items = convertItemsToCatalog(newData);
    const result = catalogs.length ? { ...catalogs[0], items } : { name: 'Каталог 1', items };
    setLoading(true);
    fetchUpdateCatalog(result)
      .then((product) => {
        toast.info('Каталог успешно сохранен');
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSave = () => {
    handleEditCatalog(catalogList);
  };

  const handleDeleteCatalogItem = (originalItem) => {
    const filter = (items) => {
      return items.reduce((a, c) => {
        if (c.id !== originalItem.id) {
          const obj = Object.assign({}, c);
          if (c.children && c.children.length) {
            obj.children = filter(c.children);
          }
          a.push(obj);
        }
        return a;
      }, []);
    };
    const newCatalogList = filter(catalogList);
    updateCatalogList(newCatalogList);
  };

  const handleEditCatalogueTitle = (originalItem, newTitle) => {
    const filter = (items) =>
      items.map((item) => {
        let newItem = {
          ...item,
          title: item.id === originalItem.id ? newTitle : item.title,
        };
        if (item.children && item.children.length) {
          newItem.children = filter(item.children);
        }
        return newItem;
      });
    const newCatalogList = filter(catalogList);
    updateCatalogList(newCatalogList);
  };

  const pageTitle = 'Настройка каталога на сайте';
  const breadcrumbs = [{ title: 'Коллекции', route: '/collections' }, { title: pageTitle }];
  //const showNotificationBlock = catalogList.length === 1 && catalogList[0].id === 'main';
  const showNotificationBlock = catalogList.length === 0;
  const catalogBlockClassName = `custom-dd dd h-100 ${
    showNotificationBlock ? 'show-notification-block' : ''
  }`;

  return (
    <Fragment>
      <PageTitle title={pageTitle} breadcrumbs={breadcrumbs} />
      <Wrapper className="row">
        <div className="col-sm-12">
          <div className="card-box card-box-custom">
            <div className="row">
              <div className="col-md-6">
                <h4 className="header-title">Коллекции</h4>
                <p className="sub-header">Перетягивайте коллекции мышкой</p>
                <DndProvider backend={Backend}>
                  <div className="custom-dd dd">
                    <ol className="dd-list" id="collectionList">
                      {collectionList.map((collection, i) => (
                        <CollectionCard
                          key={collection.id}
                          index={i}
                          originalItem={collection}
                          cardType="collection"
                        />
                      ))}
                    </ol>
                  </div>
                </DndProvider>
              </div>

              <div className="col-md-6 catalog-column">
                <h4 className="header-title mt-3 mt-md-0">Каталог товаров на сайте</h4>
                <p className="sub-header">&#8203;</p>
                <div className={catalogBlockClassName}>
                  <DndProvider backend={Backend}>
                    <TargetBox
                      moveCard={moveCatalogCard}
                      pushCard={pushCard}
                      catalogList={catalogList}
                      onDrop={handleDropToCatalog}
                      handleCollapse={handleCollapse}
                      collapsedItems={collapsedItems}
                      befores={befores}
                      setBefores={setBefores}
                      handleDeleteCatalogItem={handleDeleteCatalogItem}
                      handleEditCatalogueTitle={handleEditCatalogueTitle}
                    />
                  </DndProvider>
                  <div className="drop-notification-block">
                    <div>
                      <i className="fe-alert-circle" />
                    </div>
                    <div>Перетащите сюда коллекции из левого списка</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
      <div className="row mb-3">
        <div className="col-12">
          <Button text="Сохранить" onClick={handleSave} disabled={loading} loading={loading} />
        </div>
      </div>
    </Fragment>
  );
};

const matchStateToProps = (state) => {
  return {
    data: state.collections.data,
  };
};

const matchDispatchToProps = {
  fetchGetCollections,
  fetchGetCatalogs,
  fetchUpdateCatalog,
  showModal,
};

export default connect(matchStateToProps, matchDispatchToProps)(CatalogTuning);
